import { isCategoryPage, isDepartmentPage } from './pageType';

export const convertFreestarAdId = (adId, requestUrl) => {
    const stringToConvert = adId.substring(adId.lastIndexOf('_') + 1, adId.lastIndexOf('-'));
    const replacementString = isCategoryPage(requestUrl) ? 'Category' : 'Department';
    const convertedId = adId.replace(stringToConvert, replacementString);

    return convertedId;
};

export const getAdChannel = (adId, requestUrl) => {
    let adChannel = null;

    if (isCategoryPage(requestUrl) && adId.includes('_') && adId.includes('/')) {
        const splitId = adId?.split('_');
        const section = splitId[1].split('/');
        const [channel] = section;
        adChannel = channel;
    } else if (isDepartmentPage(requestUrl)) {
        adChannel = 'home';
    }

    return adChannel;
};

export const getFreestarAttributes = (adId, requestUrl) => {
    const shouldConvertId = isCategoryPage(requestUrl) || isDepartmentPage(requestUrl);
    const freestarAdId = adId && shouldConvertId ? convertFreestarAdId(adId, requestUrl) : adId;
    const channel = adId && shouldConvertId ? getAdChannel(adId, requestUrl) : null;

    return {
        freestarAdId,
        channel,
    };
};
